export default function () {
  return {
    hideHeader: false,
    hideFooter: false,
    uploadFile: '',
    uploadState: null,
    uploadProgress: 0
  }
}
